// utils/detectCountry.js

export function detectCountry() {
  const userLanguage = navigator.language || navigator.userLanguage || 'en';
  return userLanguage;
}
